import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class System_objects extends PureComponent {
  render() {
    return (
      <div className="row" id="system_objects">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Data Types</h2>
              <p>
                Not all system objects work the same way below is a list which
                shows what functions are available and what permissions can be
                used to access records.
              </p>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Object</td>
                    <td className="b top">Description</td>
                    <td className="b top">Permission</td>
                    <td className="b top">Actions</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>COUNTER</strong>
                    </td>
                    <td>Manages record sequential IDs.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>DASHBOARD</strong>
                    </td>
                    <td>Dashboard layouts.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>DASHBOARDREAD</td>
                    <td>Read, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>EMAIL_LOG</strong>
                    </td>
                    <td>Sent and failed email log.</td>
                    <td>ADMIN</td>
                    <td>Read, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>GROUP</strong>
                    </td>
                    <td>User groups.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>KEYWORD</strong>
                    </td>
                    <td>Keywords used for tagging of records.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>KEYWORDCREATE</td>
                    <td>Create, Read, Search</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>KEYWORDREAD</td>
                    <td>Read, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>LOGIN_AUDIT</strong>
                    </td>
                    <td>User signin log.</td>
                    <td>ADMIN</td>
                    <td>Read, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>REPORT</strong>
                    </td>
                    <td>Report layouts.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>REPORTSREAD</td>
                    <td>Read, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>RLP</strong>
                    </td>
                    <td>Record level permissions</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>SESSION</strong>
                    </td>
                    <td>User sessions.</td>
                    <td>ADMIN</td>
                    <td>Read, Delete, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>USER</strong>
                    </td>
                    <td>Nexoid users.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>USERSREAD</td>
                    <td>Read, Search</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>VARIABLE</strong>
                    </td>
                    <td>Stored variables for workflow code.</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>WORKFLOW</strong>
                    </td>
                    <td>Workflow rules</td>
                    <td>ADMIN</td>
                    <td>Create, Read, Update, Delete, Search, Audit</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>WORKFLOW_LOG</strong>
                    </td>
                    <td>Workflow execution.</td>
                    <td>ADMIN</td>
                    <td>Read, Search</td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default System_objects;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/System_objects.js